import React from 'react'

export default function ComponentsShowcase() {
  return (
    <section><a className="anchor" id="theme"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/theme-default.html"><img src="images/theme.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>Theme Showcase - Default</h1>
            <p>Live examples of all the components in the framework as would be shown with the default theme.</p>
            <p><a className="btn btn--large" href="samples/theme.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/theme.html" download>Download</a></p>
          </div>
      </div>

      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/theme-dark-grey.html"><img src="images/theme-dark.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>Theme Showcase - Dark</h1>
            <p>Live examples of all the components in the framework as would be shown with Dark theme selected</p>
            <p><a className="btn btn--large" href="samples/theme-dark-grey.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/theme-dark-grey.html" download>Download</a></p>
          </div>
      </div>

      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/theme-dark-blue.html"><img src="images/theme-dark-blue.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>Theme Showcase - Dark Blue</h1>
            <p>Live examples of all the components in the framework as would be shown with Dark Blue theme selected</p>
            <p><a className="btn btn--large" href="samples/theme-dark-blue.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/theme-dark-blue.html" download>Download</a></p>
          </div>
      </div>

      {/* <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/theme-system-preference.html"><img src="images/theme.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>Theme Showcase - System Preference</h1>
            <p>Live examples of all the components in the framework as would be shown depending on system preferences in relation to dark or light theming</p>
            <p><a className="btn btn--large" href="samples/theme-system-preference.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/theme-system-preference.html" download>Download</a></p>
          </div>
      </div> */}
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/ComponentsShowcase.js